import styles from './calendar-style.module.css'
import useWindowDimensions from '..';
import { Link } from 'react-router-dom';

var lastNotNullEvent = null;

function DetailsViewer({event}) {

    const {width} = useWindowDimensions();
    const IS_MOBILE = width < 1024;

    let offset = '0%';

    if(event == null) {
        event = lastNotNullEvent;
        offset = '100%';

        if(lastNotNullEvent == null)
            return <div id={styles.details_viewer} style={IS_MOBILE ? {left: '0', opacity: 0} : {left: '100%'}}></div>;
    } else
        lastNotNullEvent = event;


    var startDate = new Date(event?.start_date.seconds * 1000);
    var endDate = new Date(event?.end_date.seconds * 1000);

    var dates = `${startDate?.toLocaleDateString('en-US', {month: '2-digit', day: '2-digit', year: '2-digit'})} - 
             ${endDate?.toLocaleDateString('en-US', {month: '2-digit', day: '2-digit', year: '2-digit'})}`;
    
    var classification = formatClassification(event.classification);    

    return (
        <div id={styles.details_viewer} style={IS_MOBILE ? {left: '0%', opacity: (offset==="0%") ? 1 : 0} : {left: offset}}>
            <div id={styles.details_title}>
                <Link rel="noreferrer" to={'/reservation/'+event.id}>{event.name}</Link>
                <p>{classification}</p>
            </div>
            <div style={{display: 'flex', flexDirection: 'row', position: 'relative'}}>
                <div id={styles.details_left}>
                    <h2>Details:</h2>
                    <div className={styles.entry} style={{marginTop: '4px'}}>
                        <h3>Dates:</h3>
                        <p>{dates}</p>
                    </div>
                    <div className={styles.entry}  style={{marginBottom: '8px'}}>
                        <h3>Reserver:</h3>
                        <p>{event.reserver.name}</p>
                    </div>
                    {
                        event.expected_attendance != null ? 
                        ( 
                            <div className={styles.entry}>
                                <h3>Expected Attenance:</h3>
                                <p>{event.expected_attendance}</p>
                            </div>
                        ) : ""
                    }
                    {
                        event.live_registration != null ? 
                        ( 
                            <div className={styles.entry}>
                                <h3>Live Registration:</h3>
                                <p>{event.live_registration}</p>
                            </div>
                        ) : ""
                    }

                    {
                        event.matrix_link != null ?
                        (
                            <a id={styles.matrix_link} target='_blank' rel="noreferrer" href={event.matrix_link}>Link to Matrix</a>
                        ) : ""
                    }
                </div>
                <div id={styles.details_right}>
                    <h2>Locations:</h2>
                    <div id={styles.details_locations}>
                        {event.locations.map((loc) => <p key={loc}>{loc}</p>)}
                    </div>
                </div>
            </div>
        </div>
    );
}

function formatClassification(classification) {
    var words = classification.replaceAll('_', ' ').split(/\s/g);
    var formatted = "";

    for(const word of words) {
        formatted += " " + word[0].toUpperCase() + word.slice(1);
    }

    return formatted.slice(1);
}

export default DetailsViewer;